module.exports = __webpack_public_path__ + "media/images/icon_pop_close_sp-db2a1331e987085af1d759efc82fefbd.png";